import api from '@/services/api/api'

class PriceTypesService {
  getAllPriceTypes () {
    return api.get('price-type').then(result => {
      return result.data
    })
  }
}

export default new PriceTypesService()



// WEBPACK FOOTER //
// ./src/services/codebooks/PriceTypesService.js